export default "__VITE_ASSET__ClDrOwza__"